import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import {
    AtlantikNetworxxCredentialsInputDTORuntype,
    AtlantikNetworxxResponseBodyDTORuntype,
} from './atlantikNetworxxBackendTypes';

export const atlantikNetworxxEndpoints = {
    'GET /3rdparty/atlantiknetworxx/credentials': endpoint({
        description: 'Returns credentials for Atlantik Networxx integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: AtlantikNetworxxResponseBodyDTORuntype,
    }),
    'POST /3rdparty/atlantiknetworxx/credentials': endpoint({
        description: 'Uploads credentials for Atlantik Networxx API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: AtlantikNetworxxCredentialsInputDTORuntype,
        responseBody: AtlantikNetworxxResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/atlantiknetworxx/credentials'],
    }),
    'PATCH /3rdparty/atlantiknetworxx/credentials': endpoint({
        description: 'Updates credentials for Atlantik Networxx API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: AtlantikNetworxxCredentialsInputDTORuntype,
        responseBody: AtlantikNetworxxResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/atlantiknetworxx/credentials'],
    }),
    'DELETE /3rdparty/atlantiknetworxx/credentials': endpoint({
        description: 'Deletes existing credentials for Atlantik Networxx API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({ deleted: z.number() }),
        invalidates: ['GET /3rdparty/atlantiknetworxx/credentials'],
    }),
};
